import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ToastService from "../service/toast-service";
import { Z_INDEX } from "../constants";
import { IS_ELECTRON_APP } from "../config";
import { isElement } from "react-dom/test-utils";

const TOAST_TYPE = {
  INFO: 0,
  SUCCESS: 1,
  ERROR: 2,
  WARNING: 3,
};

export default class extends Component {
  toaster = (type, msg) => {
    console.log("toasting");
    const options = {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
    };
    switch (type) {
      case TOAST_TYPE.ERROR:
        toast.error(msg, options);
        break;
      case TOAST_TYPE.INFO:
        toast.info(msg, options);
        break;
      case TOAST_TYPE.WARNING:
        toast.warning(msg, options);
        break;
      case TOAST_TYPE.SUCCESS:
        toast.success(msg, options);
        break;
    }
  };

  componentDidMount() {
    ToastService.register(this.toaster);
  }

  render() {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: Z_INDEX.toast,
          top: IS_ELECTRON_APP ? "10vh" : "0vh",
        }}
      >
        <ToastContainer />
      </div>
    );
  }
}
